@let ctaFormGroup = ctaForm();

@if (ctaFormGroup) {
  <div class="custom-form gap-6 flex flex-col" [formGroup]="ctaFormGroup">
    <div class="flex flex-col">
      <span class="text-2xl">
        {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.deliverableStep.title' | translate }}
      </span>
      <span class="text-shikenso-purple-base-60">
        {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.deliverableStep.description' | translate }}
      </span>
    </div>

    @if (customModeCreatorId()) {
      <div>
        {{
          'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.changesHereOnlyApplyTo'
            | translate: { creatorName: customModeCreatorName() }
        }}
      </div>
    }

    <app-deliverable-list
      [formArray]="ctaFormGroup.controls.deliverables"
      [platformFeature]="selectedPlatformFeature()!"
      [executionValues]="executionValues()"
      [creatorId]="customModeCreatorId()"
      [isCustomMode]="!!customModeCreatorId()"
      [creators]="creators()"
      [isAllExpanded]="true"
      [deliverableConfigurations]="deliverableConfigurations()"
      [isViewMode]="false"
      [showStatusBadge]="false"
      [ctaForm]="ctaFormGroup"
    />
  </div>
}
